import React from "react"

import { OneVerifyEraUploadFileFormat } from "@common-shared/config/oneVerify/oneVerifyIntegrations.config"
import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { PopupWrapperElement } from "@front-shared/elements/popupWrapper.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"
import type { IPopupProps } from "@front-shared/types/props.types"

import { INTEGRATIONS_CONFIG } from "../../config/integrations.config"
import type { IEraUploadReviewState } from "../../types/integrations.types"
import { EraUploadFileDropzoneComponent } from "../integrations/eraUpload/eraUploadFileDropzone.component"

export const EraUploadBulkUploadPopupComponent: React.FunctionComponent<
    IEraUploadBulkUploadPopupComponentProps
> = props => {
    const isCsvReupload =
        props.fileFormat === OneVerifyEraUploadFileFormat.csv

    return (
        <PopupWrapperElement
            isActive={props.isActive}
            className={props.className}
            onDone={props.onDone}
            closeOnOutsideClick={props.closeOnOutsideClick}
            popupWidthClassName="!w-[560px] !bg-brand-white"
            withCloseIcon={true}
        >
            <div className="pt-[8px]">
                <PrimaryText
                    typography="h5"
                    color={NIRVANA_COLORS.brand.black}
                    className="mb-[8px]"
                >
                    Upload ERA file
                </PrimaryText>

                <PrimaryText
                    typography="subtitle"
                    color={NIRVANA_COLORS.brand.warmShadow}
                    className="mb-[16px]"
                >
                    {isCsvReupload
                        ? "CSV files must match the ERA upload template."
                        : `X12 835 files must include ${INTEGRATIONS_CONFIG.eraUpload.requiredX12SegmentsLabel} segments.`}
                </PrimaryText>

                {props.isActive ? (
                    <EraUploadFileDropzoneComponent
                        acceptedFileFormat={props.fileFormat}
                        onValidationDone={data => {
                            props.onValidationDone(data)
                            props.onDone()
                        }}
                    />
                ) : null}
            </div>
        </PopupWrapperElement>
    )
}

interface IEraUploadBulkUploadPopupComponentProps extends IPopupProps {
    fileFormat: OneVerifyEraUploadFileFormat
    onValidationDone: (data: IEraUploadReviewState) => void
}
